import { useTranslation } from 'react-i18next';
import { translations } from './translations';
import type { TranslationResource } from './translations.d';

/**
 * Typed translation hook.
 * - `t(key)` keeps working as before for simple string keys.
 * - `r` exposes the full strongly-typed translation resource for the active
 *   language, which avoids the awkward `t('key', { returnObjects: true }) as Type`
 *   pattern that fights react-i18next strict typing.
 */
export function useT() {
  const { t, i18n } = useTranslation();
  const langKey = (i18n.language && i18n.language.startsWith('es') ? 'es' : 'en') as 'es' | 'en';
  const r: TranslationResource = translations[langKey].translation;
  return { t, r, i18n };
}
